module.exports = (__webpack_require__(0))(66);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/MarkdownWidget.js from dll-reference girder_lib
// module id = 18
// module chunks = 0